import { LocalStorageKey } from 'shared/constants/localStorage'
import { AppConfig } from 'shared/types/app'

import { lsGetItem } from './local-storage'

const PERMISSION_VIEW_TEMPLATE = 'can-view-app'

export const hasViewPermission = (app: AppConfig) => {
  const user = lsGetItem(LocalStorageKey.USER)
  if (!user) return false

  const permissions = user ? new Set(user?.permissions) : undefined

  return permissions?.has(`${app.slug}.${PERMISSION_VIEW_TEMPLATE}`)
}
